// The Comic Machine - Asset

var Asset = (function() {

  // Configuration settings/properties
  var defaults = {};

  // An Asset object to be managed by a Collection
  function Asset(options, callback) {

    options = options || {};

    var asset = this;

    // Set the image data
    this.image = options.image || null;
    this.file = options.file || null;

    if (this.file === null) return console.log("no file");

    // Set the size
    this.width = this.image.width || options.width;
    this.height = this.image.height || options.height;

    // Set the asset meta, including name
    this.name = this.image.name || options.name;

    // Create the payload
    var data = new FormData();
    data.append("comic", options.comic || Comic.current.uid);
    data.append("name", this.name);
    data.append("image", this.file);
    data.append("width", this.width);
    data.append("height", this.height);

    // Make the API request
    API.assets.create(data, function(success, response) {
      if (success) {
        var url = API.config.assets + response.url;
        // Log the response
        // console.log("success", response);
        // Assign the values returned from the API
        asset.comic = response.comic;
        asset.mime = response.mime;
        asset.name = response.name;
        asset.size = response.size;
        asset.type = response.type;
        asset.uid = response.uid;
        asset.user = response.user;
        asset.url = url;
        asset.width = response.width;
        asset.height = response.height;
        // Fire the callback, if present
        callback && callback(response);
      } else {
        // Display the alert to the user
        window.alert("An error occurred, please try again.");
        // Log the response
        console.error("error", response);
      }
    });

  }

  // Queries an asset based on UID
  Asset.query = function(uid, comic, callback) {

    var data = {
      uid: uid,
      keepNotification: true,
      comic: comic
    };

    // Make the API request
    API.assets.query(data, function(success, response) {
      if (success) {
        // Log the response
        // console.log("success", response);
        // Fire the callback, if present
        callback && callback(response);
      } else {
        // Log the response
        console.error("error", response);
      }
    });

  };

  // Loads an image and draws it to the canvas
  Asset.load = function(uid, comic, callback) {

    // Make the API request
    Asset.query(uid, comic, function(asset) {
      asset = asset[0];
      var url = API.config.assets + asset.url.replace("/assets", "");
      Asset.loadImage(url, function(image) {
        // Fire the callback, if present
        callback && callback(asset, image);
      });
    });

  };

  // Method to load an image asset
  Asset.loadImage = function(src, callback) {

    var image = document.createElement("img");

    // On image load, fire the callback, if present
    image.onload = function(event) {
      console.log("loaded");
      callback && callback(image);
    };

    // On image error, fire the callback, if present
    image.onerror = function(event) {
      console.error("Asset.loadImage", event);
      callback && callback(null);
    };

    // Set the cross origin property
    image.crossOrigin = "";

    // Set the src of the image
    image.src = src;

  };

  // Public / exposed class
  return Asset;

})();
